import script from "./SkypeConvWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkypeConvWindow.vue?vue&type=script&lang=ts&setup=true"

import "./SkypeConvWindow.vue?vue&type=style&index=0&id=d5ba4190&lang=css"

const __exports__ = script;

export default __exports__